import { Component, OnDestroy, OnInit, SimpleChanges, OnChanges, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output, HostListener, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup } from '@angular/forms';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../../services/dashboard.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { PrintService } from '../../services/print.service';
import { InventoryService } from '../../services/inventory.service';
import { ReportsService } from '../../services/reports.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';


@Component({
	selector: 'app-brand-report',
	templateUrl: './brand-report.component.html',
	styleUrls: ['./brand-report.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(-179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('inactive => active', animate('250ms ease-in')),
			transition('active => inactive', animate('250ms ease-out')),
		]),
		trigger('openClose', [
			state(':enter', style({ height: '*' })),
			state(':leave', style({ height: '0px' })),
			transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
			transition(':enter, * => 0, * => -1', []),
			transition(':increment', [
				query(':enter', [
					style({ opacity: 0, width: 0 }),
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 1, width: '*' })),
					]),
				], { optional: true })
			]),
			transition(':decrement', [
				query(':leave', [
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 0, width: 0 })),
					]),
				])
			]),
		]),
		trigger('grow', [
			transition(':enter', [
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				animate(100, style({ height: 0, width: 0, overflow: 'hidden' })),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class BrandReportComponent implements OnInit {

	@Output() viewData = new EventEmitter < any > ();
	@Input() customer;
	@Input() vendor;
	@Input() menuapp: any = false;
	@Input() injectedData: any = false;
	@Input() pos: any = false;

	@ViewChild('print_items') print_itemsRef: ElementRef;
	viewing: any = false;


	data: any = false;
	title = 'Brand report';

	currentcarts: any = [];
	cartagebuckets: any = [];
	cartsettings: any = [];
	location: any = false;

	cartdetails: any = [];
	user: any = false;
	color: any = 'blue';
	expanded = false;
	alldata: any = false;

	properties: any = false;
	locations: any = false;
	todate = new Date();
	fromdate = new Date();
	today = new Date();
	sending: any = false;


	categoryid = new UntypedFormControl('');
	lineid = new UntypedFormControl('');
	defaultlocation = new UntypedFormControl('');
	fromdateCtrl = new UntypedFormControl('');
	todateCtrl = new UntypedFormControl('');
	brands = new UntypedFormControl([]);
	grouplocations = new UntypedFormControl(true);
	charttitle: any = 'Brand Sales';
	filename = 'Brand Sales';
	dataload: any = false;

	limits: any = [5, 10, 15, 20, 25, 30, 50, 100, 'NO LIMIT']
	limit = new UntypedFormControl();
	flip = 'inactive';
	showdata: any = false;

	brandorpline = 'BRAND';
	config: any = false;

	// ── Grouping / breakdown ──────────────────────────────────────────────────
	// groupby drives the bars; detailby optionally nests a breakdown under each.
	groupby = new UntypedFormControl('BRAND');
	detailby = new UntypedFormControl('');
	salespersons = new UntypedFormControl([]);

	groupOptions: any = [
		{ value: 'BRAND', name: 'Brand' },
		{ value: 'PLINE', name: 'Product Line' },
		{ value: 'CATEGORY', name: 'Category' },
		{ value: 'SALESPERSON', name: 'Salesperson' },
		{ value: 'CUSTOMER', name: 'Customer' },
	];
	detailOptions: any = [
		{ value: '', name: 'None' },
		{ value: 'PLINE', name: 'Product Line' },
		{ value: 'CATEGORY', name: 'Category' },
		{ value: 'SALESPERSON', name: 'Salesperson' },
		{ value: 'CUSTOMER', name: 'Customer' },
		{ value: 'BRAND', name: 'Brand' },
	];

	grouplabel = 'Brand';
	detaillabel = '';
	/** true when the signed-in user is a rep — the salesperson filter is then pinned server-side. */
	issalesman = false;
	salesmangated = false;
	salespeople: any = [];
	/** keyval -> open, for the per-row detail panels. */
	openDetails: { [key: string]: boolean } = {};
	/** Unnarrowed lookup lists, kept so clearing the brand filter restores them. */
	allproductlines: any = [];
	allcategories: any = [];

	// ── Expanded (fullscreen) view ────────────────────────────────────────────
	// Same move as Route Builder v2's focus mode: pin the card to the viewport
	// so it reclaims the app sidebar and top nav. Ten stacked bars plus their
	// detail panels do not fit in a dashboard tile.
	// Deliberately NOT persisted the way RB2 persists focus: this widget is
	// mounted more than once on the dashboard, so a remembered flag would pop
	// every copy open at load and they would sit on top of each other.
	expandedView = false;
	private priorBodyOverflow: string | null = null;
	// Where the host sat before it was teleported, so it goes back exactly.
	private origParent: any = null;
	private origNext: any = null;

	datasub: any = false;
	showFilters = false;
	drillLoading = false;   // overlay spinner when drilling into a bar click
	barsReady   = false;   // toggled to true after data loads to trigger CSS width transition
	maxBarValue = 0;       // max total value across current data for bar scaling

	// breadcrumb stack: each entry is { title, brands, lineid, brandorpline }
	drillStack: { title: string; brands: any[]; lineid: any[]; brandorpline: string; groupby: string }[] = [];

	prefix: any = false;
	labeltype: any = false;

	// Theme palette — keyed by the `color` value from globalSearchService
	private static readonly THEME_PALETTE: Record<string, { light: [number, number, number]; base: [number, number, number]; dark: [number, number, number] }> = {
		purple:  { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		primary: { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		blue:    { light: [144, 202, 249], base: [ 33, 150, 243], dark: [ 25, 118, 210] },
		info:    { light: [128, 222, 234], base: [  0, 188, 212], dark: [  0,  96, 100] },
		green:   { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		success: { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		orange:  { light: [255, 204, 128], base: [255, 152,   0], dark: [230,  81,   0] },
		warning: { light: [255, 224, 130], base: [255, 193,   7], dark: [255, 143,   0] },
		red:     { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		danger:  { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		rose:    { light: [244, 143, 177], base: [233,  30,  99], dark: [136,  14,  79] },
	};

	get themePalette() {
		return BrandReportComponent.THEME_PALETTE[this.color] || BrandReportComponent.THEME_PALETTE['blue'];
	}

	get themeVars(): { [key: string]: string } {
		const p = this.themePalette;
		const rgb  = (c: number[]) => `rgb(${c[0]},${c[1]},${c[2]})`;
		const rgba = (c: number[], a: number) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
		return {
			'--br-accent':        rgb(p.base),
			'--br-accent-dark':   rgb(p.dark),
			'--br-accent-light':  rgb(p.light),
			'--br-accent-tint':   rgba(p.base, 0.08),
			'--br-accent-tint-2': rgba(p.base, 0.14),
			'--br-accent-border': rgba(p.base, 0.22),
			'--br-accent-bg':     rgba(p.light, 0.18),
		};
	}

	constructor(private inventoryService: InventoryService, private printService: PrintService, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, private dashboardService: DashboardService, private reportsService: ReportsService, private el: ElementRef, private renderer: Renderer2, private modalService: NgbModal) {

		this.color = 'primary';
		this.limit.setValue(10);
		const today = new Date();
		const priorDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
		this.fromdate = priorDate;
		this.fromdateCtrl.setValue(this.fromdate);
		this.todateCtrl.setValue(this.todate);

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			if(this.config.env.package === 'tires'){
				this.labeltype = 'Units';
				this.prefix = false;
			}else{
				this.labeltype = '$';
				this.prefix = true;
			}
		})
		this.globalSearchService.user.subscribe(r => {
			this.user = r;
			this.issalesman = !!r?.user?.issalesman;

			this.globalSearchService.locations.subscribe(async (results: any) => {
				this.locations = results;

				if (results) {
					const val = [
						this.user.user.defaultlocation.loccode
					];
				}
			});
		})

		this.globalsService.getItemSetup().subscribe((results: any) => {
			this.properties = results;
			// Keep the full lists so clearing the brand filter can widen back out
			// without another round-trip.
			this.allproductlines = results?.productlines || [];
			this.allcategories = results?.categories || [];
			this.brands.valueChanges.subscribe(r => {
				this.onBrandsChange();
			})
		});
	}

	ngOnInit(): void {
		this.expanded = false;

		// reports/salespeople already pins itself to the rep's own code for
		// sales-channel users, so this list is safe to load either way.
		this.reportsService.getSalesPeople().subscribe((r: any) => {
			this.salespeople = Array.isArray(r) ? r : [];
		});
	}

	toggleExpanded() {
		this.data = false;
		if (this.expanded) {
			this.expanded = false;
		} else {
			this.expanded = true;
		}

		this.loadData();
	}

	getBarPct(d: any): number {
		return this.maxBarValue > 0 ? Math.min((parseFloat(d.total) / this.maxBarValue) * 100, 100) : 0;
	}

	getPctOfTotal(d: any): string {
		const total = this.getTotal();
		return total > 0 ? ((parseFloat(d.total) / total) * 100).toFixed(0) : '0';
	}

	formatShort(v: number | string): string {
		const n = parseFloat(String(v)) || 0;
		if (n >= 1_000_000) { return '$' + (n / 1_000_000).toFixed(1) + 'M'; }
		if (n >= 1_000)     { return '$' + (n / 1_000).toFixed(0) + 'k'; }
		return '$' + n.toFixed(0);
	}

	/** Bars are only drillable when they represent brands and nothing is nested under them. */
	get canDrill(): boolean {
		return this.groupby.value === 'BRAND' && !this.detailby.value;
	}

	onBarClick(label: string): void {
		if (!this.canDrill) { return; }
		this.drillStack.push({
			title: this.charttitle,
			brands: this.brands.value,
			lineid: this.lineid.value,
			brandorpline: this.brandorpline,
			groupby: this.groupby.value,
		});
		this.drillLoading = true;
		this.loadBrandSale(label);
	}

	toggleExpandedView(): void {
		if (this.expandedView) { this.collapseView(); } else { this.expandView(); }
	}

	expandView(): void {
		if (this.expandedView) { return; }
		this.expandedView = true;

		// Teleport the host to <body> before going fixed. This widget is mounted
		// inside dashboard tiles, and a tile with a transform on it makes
		// position:fixed resolve against the tile instead of the viewport — the
		// overlay would be trapped in the card. Same fix as remittance-import.
		const host = this.el.nativeElement;
		this.origParent = host.parentNode;
		this.origNext = host.nextSibling;
		this.renderer.appendChild(document.body, host);

		// A fixed layer still lets the document scroll underneath, which reads as
		// the card drifting.
		this.priorBodyOverflow = document.body.style.overflow;
		this.renderer.setStyle(document.body, 'overflow', 'hidden');
	}

	collapseView(): void {
		if (!this.expandedView) { return; }
		this.expandedView = false;

		const host = this.el.nativeElement;
		if (this.origParent) {
			if (this.origNext) {
				this.renderer.insertBefore(this.origParent, host, this.origNext);
			} else {
				this.renderer.appendChild(this.origParent, host);
			}
		}
		this.origParent = null;
		this.origNext = null;

		this.releaseBodyScroll();
	}

	private releaseBodyScroll(): void {
		if (this.priorBodyOverflow === null) { return; }
		this.renderer.setStyle(document.body, 'overflow', this.priorBodyOverflow);
		this.priorBodyOverflow = null;
	}

	@HostListener('document:keydown.escape')
	onEscapeKey(): void {
		// Each mounted copy gets this; only the expanded one reacts.
		if (this.expandedView) { this.collapseView(); }
	}

	/** Chart/table row click: drill when drillable, otherwise open the detail panel. */
	onRowClick(d: any): void {
		if (this.canDrill) {
			this.onBarClick(d.label);
			return;
		}
		if (this.hasDetails(d)) {
			this.toggleDetails(d);
		}
	}

	hasDetails(d: any): boolean {
		return !!(d?.details && d.details.length);
	}

	detailKey(d: any): string {
		return String(d?.keyval ?? d?.label ?? '');
	}

	isDetailOpen(d: any): boolean {
		return !!this.openDetails[this.detailKey(d)];
	}

	toggleDetails(d: any): void {
		const k = this.detailKey(d);
		this.openDetails[k] = !this.openDetails[k];
	}

	expandAllDetails(): void {
		(this.data || []).forEach((d: any) => {
			if (this.hasDetails(d)) { this.openDetails[this.detailKey(d)] = true; }
		});
	}

	collapseAllDetails(): void {
		this.openDetails = {};
	}

	get anyDetailOpen(): boolean {
		return Object.keys(this.openDetails).some(k => this.openDetails[k]);
	}

	/** Detail bar width is relative to its own parent row, not the whole chart. */
	getDetailPct(parent: any, d: any): number {
		const max = Math.max(...(parent?.details || []).map((x: any) => Math.abs(parseFloat(x.total) || 0)), 1);
		return Math.min((Math.abs(parseFloat(d.total) || 0) / max) * 100, 100);
	}

	getDetailPctOfParent(parent: any, d: any): string {
		const t = parseFloat(parent?.total) || 0;
		return t !== 0 ? ((parseFloat(d.total) / t) * 100).toFixed(0) : '0';
	}

	/** Group-by / detail-by / salesperson changes all re-query. */
	onDimensionChange(): void {
		this.openDetails = {};
		this.drillStack = [];
		this.loadData();
	}

	/** "Category" -> "Categories", "Brand" -> "Brands". */
	pluralize(word: string, count?: number): string {
		const w = String(word || '');
		if (!w) { return ''; }
		if (count === 1) { return w; }
		if (/person$/i.test(w)) { return w.replace(/person$/i, 'people'); }
		return /[^aeiou]y$/i.test(w) ? w.slice(0, -1) + 'ies' : w + 's';
	}

	get groupPlural(): string {
		return this.pluralize(this.grouplabel);
	}

	/** Product Line / Category pickers are showing only what the chosen brands carry. */
	get brandsNarrowed(): boolean {
		return !!(this.brands.value && this.brands.value.length);
	}

	private applyMeta(results: any): void {
		this.grouplabel = results?.grouplabel || 'Brand';
		this.detaillabel = results?.detaillabel || '';
		this.salesmangated = !!results?.salesmangated;
		if (results?.groupby) {
			this.groupby.setValue(results.groupby, { emitEvent: false });
		}
		this.brandorpline = this.grouplabel.toUpperCase();
	}

	async loadData (): Promise < void > {
		const search = {
			limit: this.limit.value,
			location: this.defaultlocation.value,
			brands: this.brands.value,
			from: this.fromdateCtrl.value,
			to: this.todateCtrl.value,
			categories: this.categoryid.value,
			pline: this.lineid.value,
			grouplocations: this.grouplocations.value,
			debtorno: this.customer?.debtorno || false,
			vendor: this.vendor?.supplierid || false,
			issalesman: this.user?.user?.issalesman ? this.user.user.salesman : false,
			// Reps are pinned server-side; sending the control value anyway is
			// harmless because the server ignores it for gated users.
			salesperson: this.salespersons.value || [],
			groupby: this.groupby.value || 'BRAND',
			detailby: this.detailby.value || '',
		};

		// Unsubscribe from the previous data load if active
		if (this.dataload) {
			this.dataload.unsubscribe();
		}

		this.sending = true;

		this.dataload = this.dashboardService.getBrandReport(search).subscribe({
			next: (results: any) => {
				this.sending = false;
				this.drillLoading = false;

				if (!results?.data) {return;} // Exit if no data is returned

				this.alldata = results.data;
				this.data = results.data;

				this.applyMeta(results);

				this.maxBarValue = Math.max(...results.data.map((d: any) => parseFloat(d.total) || 0), 1);
				this.barsReady = false;
				setTimeout(() => { this.barsReady = true; }, 60);
			},
			error: (err: unknown) => {
				this.sending = false;
				this.drillLoading = false;
				const msg = err instanceof Error ? err.message : (typeof err === 'object' && err !== null && 'message' in err) ? (err as { message: string }).message : String(err);
				console.error('Error loading brand data:', msg);
			},
		});
	}

	/**
	 * Brand selection changed: narrow the Product Line and Category pickers to
	 * what those brands actually carry, and drop any now-invalid selection.
	 */
	onBrandsChange() {
		this.updateProductLines();
		this.updateCategories();
	}

	updateProductLines() {
		const brands = this.brands.value || [];

		if (!brands.length) {
			this.properties.productlines = this.allproductlines;
			this.pruneSelection(this.lineid, this.allproductlines, ['line_field', 'value']);
			return;
		}

		this.inventoryService.getBrandProductlines({ brands }).subscribe((r: any) => {
			this.properties.productlines = Array.isArray(r) ? r : [];

			// Narrow the picker to the brand's lines, but do NOT select them all.
			// Selecting every line adds a `lineid IN (...)` filter on top of the
			// brand filter, which silently drops any sale whose lineid has no
			// productlines row — so the brand's total stops matching the chart.
			this.pruneSelection(this.lineid, this.properties.productlines, ['line_field', 'value']);
		});
	}

	updateCategories() {
		const brands = this.brands.value || [];

		if (!brands.length) {
			this.properties.categories = this.allcategories;
			this.pruneSelection(this.categoryid, this.allcategories, ['value', 'categoryid']);
			return;
		}

		this.inventoryService.getBrandCategories({ brands }).subscribe((r: any) => {
			this.properties.categories = Array.isArray(r) ? r : [];
			this.pruneSelection(this.categoryid, this.properties.categories, ['value', 'categoryid']);
		});
	}

	/** Keep only the selected values that still exist in the narrowed option list. */
	private pruneSelection(control: UntypedFormControl, options: any[], keys: string[]) {
		const available = (options || []).map((o: any) => {
			for (const k of keys) {
				if (o?.[k] !== undefined && o[k] !== null) { return o[k]; }
			}
			return undefined;
		});
		const keep = (control.value || []).filter((v: any) => available.indexOf(v) > -1);
		if (keep.length !== (control.value || []).length) {
			control.setValue(keep, { emitEvent: false });
		}
	}

	loadBrandSale(i: any) {

		const wanted = String(i || '').trim().toUpperCase();
		const brand_focus = this.properties.brands.filter(r => {
			return String(r.name || '').trim().toUpperCase() === wanted;
		})[0];

		if (brand_focus) {
			this.expanded = true;
			this.charttitle = brand_focus.name + ' ' + 'Brand Sales';
			this.brandorpline = 'PRODUCT LINE';
			this.groupby.setValue('PLINE', { emitEvent: false });
			this.openDetails = {};
			this.brands.setValue([brand_focus.manufacturer_id])
			this.loadData();
		}
	}

	getTotal() {

		const value = this.data.reduce(function(accumulator: number, items: any) {
			const addon = parseFloat(items.total);
			return accumulator + addon;
		}, 0);

		return value;
	}


	toggleFlip(data: any, title: string) {

		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title
			const dashboard_data = { data: data, title: this.title }
			this.viewData.emit(dashboard_data);
		} else {
			this.viewData.emit(false);
		}
	}

	backOne() {
		this.brands.setValue([]);
		this.lineid.setValue([]);
		this.categoryid.setValue([]);
		this.title = 'Brand Sales';
		this.charttitle = 'Brand Sales';
		this.brandorpline = 'BRAND';
		this.groupby.setValue('BRAND', { emitEvent: false });
		this.openDetails = {};
		this.drillStack = [];
		this.loadData();
	}

	drillBack(): void {
		const prev = this.drillStack.pop();
		if (!prev) { return; }
		this.charttitle  = prev.title;
		this.brandorpline = prev.brandorpline;
		this.groupby.setValue(prev.groupby || 'BRAND', { emitEvent: false });
		this.openDetails = {};
		this.brands.setValue(prev.brands);
		this.lineid.setValue(prev.lineid);
		this.loadData();
	}

	exportPdf() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(this.print_itemsRef.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: this.charttitle,
			subtitle: (this.defaultlocation.value != '' ? ' Locations:' + this.defaultlocation.value.join(',') + ' ' : '') + this.fromdateCtrl.value.toLocaleDateString() + ' - ' + this.todateCtrl.value.toLocaleDateString() + ' created ' + today.toLocaleString()
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.sending = false;
		});
	}

	selectAllToggle(input: MatSelect) {
		//tired coming back to
		const currentvalue = input.value;
		if (currentvalue.length) {
			input.value = [];
		} else {
			const allvalues = input.options.map(r => {
				return r.value;
			});
			input.value = allvalues;
		}
	}

	toggleData() {
		this.flip = (this.flip == 'active') ? 'inactive' : 'active';
	}

	exportXls() {
		this.sending = true;

		const encoded: string = this.globalSearchService.base64encode(this.print_itemsRef.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: this.charttitle,
			subtitle: (this.defaultlocation.value != '' ? ' Locations:' + this.defaultlocation.value.join(',') + ' ' : '') + this.fromdateCtrl.value.toLocaleDateString() + ' - ' + this.todateCtrl.value.toLocaleDateString() + ' created ' + today.toLocaleString()
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}

	ngOnChanges(changes: any) {

		if (changes.customer) {

			if (changes.customer.currentValue) {
				this.limit.setValue(10);
				const today = new Date();
				const priorDate = new Date(today.getFullYear(), today.getMonth() - 12, 1);
				this.fromdate = priorDate;
				this.fromdateCtrl.setValue(this.fromdate);
				this.todateCtrl.setValue(this.todate);
			}
			if (!this.injectedData['dummydata']) {
				this.loadData();
			} else {
				this.loadLocalData();
			}
		}

		if (changes.vendor) {

			if (changes.vendor.currentValue) {
				this.limit.setValue(10);
				const today = new Date();
				const priorDate = new Date(today.getFullYear(), today.getMonth() - 12, 1);
				this.fromdate = priorDate;
				this.fromdateCtrl.setValue(this.fromdate);
				this.todateCtrl.setValue(this.todate);
			}
			if (!this.injectedData['dummydata']) {
				this.loadData();
			} else {
				this.loadLocalData();
			}
		}

	}

	loadLocalData() {
		const results = this.injectedData['dummybrandbylocation']
		this.sending = false;

		if (!results?.data) {return;} // Exit if no data is returned

		this.alldata = results.data;
		this.data = results.data;

		this.applyMeta(results);

		this.maxBarValue = Math.max(...results.data.map((d: any) => parseFloat(d.total) || 0), 1);
		this.barsReady = false;
		setTimeout(() => { this.barsReady = true; }, 60);
	}

	reset() {
		this.charttitle = 'Brand Sales';
		this.brandorpline = 'BRAND';
		this.groupby.setValue('BRAND', { emitEvent: false });
		this.detailby.setValue('', { emitEvent: false });
		this.categoryid.setValue([]);
		this.salespersons.setValue([]);
		this.openDetails = {};
		this.drillStack = [];
		this.brands.setValue([]);
		this.lineid.setValue([]);
		this.loadData();
	}

	ngOnDestroy() {
		// Never leave the page unscrollable if the card is torn down while expanded.
		this.releaseBodyScroll();
		if (this.dataload) {
			this.dataload.unsubscribe();
		}
	}

}